import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { canAccessDepartmentDashboard } from "../../lib/dashboardRole";
import DepartmentDashboard from "./DepartmentDashboard";

/** Department overview dashboard — foreman of that department only. */
export default function ForemanDepartmentDashboard({ department }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-[40vh] grid place-items-center text-sm text-muted-foreground">Loading…</div>
    );
  }

  if (!canAccessDepartmentDashboard(user?.role, department)) {
    return <Navigate to={`/production/${department}`} replace />;
  }

  return <DepartmentDashboard department={department} />;
}
